<script async setup lang="ts"></script>

<template>
  <slot name="main"></slot>
</template>

<style scoped></style>
